module.exports = __webpack_public_path__ + "static/img/default_img_requestAborted.127c8009.png";